import _merge from 'lodash/merge';
import _cloneDeep from 'lodash/cloneDeep';

export default class MapController {
    /** @ngInject */
    constructor($q, EventEmitter) {
        this.$q = $q;
        this.defer = this.$q.defer();
        this.eventEmitter = EventEmitter;
        this.geocoder = new google.maps.Geocoder();
    }

    $onInit() {
        this.handleOptions();

        this.$q.when(this.defer.promise).then((map) => {
            google.maps.event.trigger(map, 'resize');

            const input = document.getElementById('ngMapAutocomplete');
            map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
            const autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);

            map.setCenter(new google.maps.LatLng(this.centerCoordinates.lat, this.centerCoordinates.lng));
        });

        this.mapClickedBound = this.onMapClick.bind(this);
        this.boundsChangedBound = this.boundsChanged.bind(this);
        this.centerChangedBound = this.centerChanged.bind(this);
    }

    handleOptions() {
        this.options = {
            scrollwheel: true,
            zoom: 6
        };

        _merge(this.options, this.mapOptions);
    }

    boundsChanged() {
        if (this.map) {
            const bounds = this.map.getBounds();
            const boundsStr = bounds.toString();
            const [swLat, swLng, neLat, neLng] = boundsStr
                .split(',')
                .map(value => parseFloat(value.replace(/[ ()]/g, '')));
            this.onBoundsChanged(
                this.eventEmitter({
                    bounds: {
                        southWest: {
                            lat: swLat,
                            lng: swLng
                        },
                        northEast: {
                            lat: neLat,
                            lng: neLng
                        }
                    }
                })
            );
        }
    }

    centerChanged() {
        if (this.map) {
            const lat = this.map.center.lat();
            const lng = this.map.center.lng();
            this.onCenterChanged(
                this.eventEmitter({
                    center: {
                        lat,
                        lng
                    }
                })
            );
        }
    }

    onSearch(ev, $ctrl) {
        const place = this.getPlace();

        $ctrl.map.setCenter(place.geometry.location);
    }

    onMapInitialized(map) {
        this.defer.resolve(map);
        this.map = map;
    }

    onMapClick(ev) {
        if (this.onMarkerCoordinatesChanged) {
            this.markerCoordinatesChanged(ev);
        }
    }

    markerCoordinatesChanged(ev) {
        if (!this.marker) {
            this.marker = {};
        }
        this.marker.lat = ev.latLng.lat();
        this.marker.lng = ev.latLng.lng();
        this.getGeoLocation(this.marker);
    }

    getGeoLocation() {
        if (!this.marker || !this.marker.lat || !this.marker.lng) return;
        this.geocoder.geocode(
            { 'location': this.marker },
            (results, status) => {
                if (status === 'OK') {
                    this.marker.address = results[0].formatted_address;
                    this.pushData();
                }
            });
    }

    pushData() {
        this.onMarkerCoordinatesChanged(
            this.eventEmitter({
                marker: _cloneDeep(this.marker)
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/common/map/map.controller.js